module.exports = __webpack_public_path__ + "static/media/sermos_purple_RGB.692134cf.png";